import { Card, CardContent } from '@shared/shared-shadcn-ui';
import { cn } from '@shared/shared-utils';
import { FC, useRef, useEffect } from 'react';
import { Button } from '../../../../../../../../../libs/components/components';
import ArrowRightIcon from '../../../../../../../../../../public/svg/arrow-right.svg';

type Properties = {
  caption: string;
  src: string;
  thumbnail?: string;
  isActive?: boolean;
  onClick?: () => void;
  className?: string;
  onNextVideoClick: () => void;
  videoRef?: (ref: HTMLVideoElement | null) => void;
};

const VideoThoughtsCarouselMobileCard: FC<Properties> = ({
  caption,
  src,
  thumbnail,
  isActive = false,
  onClick,
  className,
  onNextVideoClick,
  videoRef,
}: Properties) => {
  const internalVideoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef && internalVideoRef.current) {
      videoRef(internalVideoRef.current);
    }
  }, [videoRef]);

  return (
    <Card
      onClick={onClick}
      className={cn(
        'cursor-pointer transition-all duration-300 ease-in-out border-0 margin-0 h-full flex flex-col w-full max-w-full min-w-0 overflow-hidden rounded-[16px]',
        !isActive ? 'bg-ogn-blue hover:bg-ogn-blue/90' : 'bg-ogn-white',
        className,
      )}
    >
      <CardContent className="p-0 flex-1 min-w-0 overflow-hidden">
        <div className="bg-gray-400 w-full h-auto aspect-[2/1] transition-transform duration-300 overflow-hidden max-w-full">
          <video
            ref={internalVideoRef}
            src={src}
            poster={thumbnail}
            className="w-full h-full object-cover"
            controls
            preload="metadata"
          />
        </div>
        <div className="p-6 flex flex-col gap-y-4">
          <p
            className={cn(
              'text-[35px] font-bold transition-colors duration-300',
              !isActive ? 'text-ogn-white' : 'text-ogn-blue',
            )}
          >
            {caption}
          </p>
          <Button
            variant="white"
            className="flex items-center justify-center gap-x-2 justify-self-center mx-auto mb-6 py-[15px] text-[23px] rounded-full w-[200px] font-roboto-condensed"
            onClick={onNextVideoClick}
          >
            Next video <ArrowRightIcon className="w-[20px] h-[20px]" />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export { VideoThoughtsCarouselMobileCard };
